import { Helmet } from 'react-helmet-async';
import React from 'react';
import ProjectsContainer from '../../containers/projects/ProjectsContainer.jsx';
import { getOrgTermsContent } from '../../content/utils.js';
import requireAuth from '../../lib/requireAuth.jsx';
import withRouterParams from '../../lib/withRouterParams.jsx';

const Projects = ({ query, slug }) => (
  <>
    <Helmet>
      <title>{getOrgTermsContent('projects')} | ChangeSync</title>
    </Helmet>
    <ProjectsContainer query={query} slug={slug} archived={false} />
  </>
);

export default requireAuth(withRouterParams(Projects));
